// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"519":"842ee069","994":"b750a749"}[chunkId] + ".chunk.css";
};